// extracted by mini-css-extract-plugin
export default {"page_wrap":"JobDescription_page_wrap__nq0a6","column_wrap":"JobDescription_column_wrap__3Jd9O"};